import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { Area } from '../../DataStructures/Area/Area';
import { Trip } from '../../DataStructures/Trip/Trip';
import { OptimizerResult } from '../../DataStructures/OptimizerResult/OptimizerResult';
import { RunHistory } from '../../DataStructures/RunConfiguration/RunHistory';
import { Report } from '../../DataStructures/Report/Report';
import * as moment from "moment";
import { RunConfig } from '../../DataStructures/RunConfiguration/RunConfig';
import { TimeSlot } from '../../DataStructures/TimeSlot/TimeSlot';
import { AuthService } from '../auth-service/auth.service';
@Injectable()
export class MainService {

  constructor(private http: Http) {

  }

  public deliveryRequest(payload) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}trip/delivery-request`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, payload, { headers: headers }).toPromise().then(res => res.json())
  }


  public createTrip(payload) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}trip`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, payload, { headers: headers }).toPromise().then(res => res.json())
  }

  public drivers() {
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json())
  }

  rateTrip(tripid, payload) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}trip/rating?tripid=${tripid}`;
    return this.http.post(url, payload).toPromise().then(res => res.json())
  }

  createUser(payload) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}admin/user`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, payload, { headers: headers }).toPromise().then(res => res.json())
  }

  public emailTrackingLink(email, link) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/tracking-link`;
    var payload = {
      email: email,
      link: link
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }

  public getTrackingLink(tripid, allowLocation = false, allowPhone = false) {

    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/tracking-link?tripid=${tripid}`;
    if (allowLocation) {
      url += `&allow=1`
    }
    if (allowPhone) {
      url += '&allowPhone=1'
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public loadTrackingInfo(link) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/tracking-info?info=${link}`;
    return this.http.get(url).toPromise().then(res => res.json())
  }

  public driverPayroll(startDate, endDate, driverId = null, companyid = null) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}driver/payroll?startDate=${startDate}&endDate=${endDate}`;
    if (driverId) {
      url += `&driverid=${driverId}`
    }
    if (companyid) {
      url += `&companyid=${companyid}`
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }


  public reverseGeocode(request): Promise<any> {
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.REVERSE_GEOCODE;
    return this.http.post(url, request).toPromise().then(res => res.json());
  }

  public getCluster(body: any): Promise<any> {

    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.OPTIMIZE;
    return this.http.post(
      url,
      body
    ).toPromise().then(resp => {
      return {
        req: body,
        res: resp.json(),
        url: url
      }
    })
  }


  public calculatecDistanceMatrix(areas: Array<Area>, origin: any): Promise<String> {

    let body = {
      origin: origin,
      areas: areas
    };
    return this.http.post(ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.C_DISTANCE_MATRIX, body)
      .toPromise().then(res => res.json());
  }

  public closestPoint(areas: Array<Area>, source: Area): Promise<String> {

    let body = {
      source: source,
      points: areas
    };

    return this.http.post(ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CLOSEST_POINT, body)
      .toPromise().then(res => res.json());
  }


  public calculateDistanceMatrix(areas: Array<Area>, origins: Array<any>): Promise<String> {

    let body = {
      origins: origins,
      areas: areas
    };
    return this.http.post(ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DISTANCE_MATRIX, body)
      .toPromise().then(res => res.json());
  }

  public saveOptimizerResult(result: OptimizerResult): Promise<string> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.OPTIMIZER_RESULT;
    return this.http.post(url, result).toPromise().then(res => res.json());
  }

  public saveRunHistoryForResult(history: RunHistory): Promise<string> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RUN_HISTORY;
    return this.http.post(url, history).toPromise().then(res => res.json());
  }

  public getOptimizerResult(id: string): Promise<string> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.OPTIMIZER_RESULT + "/" + id;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public getRunHistory(properties: any): Promise<string> {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_RUN_HIST;
    return this.http.post(url, properties).toPromise().then(res => res.json());
  }

  public saveReport(sd, ed, report, saveNew = true) {
    delete report.runConfig.loader;
    var allTrips: Array<Trip> = [];
    for (var i = 0; i < report.days.length; i++) {
      var d = report.days[i];
      for (var j = 0; j < d.trips.length; j++) {
        var t = d.trips[j];
        allTrips.push(t);
      }
    }
    var formatted = Report.buildWeekFormat(moment(sd), moment(ed), allTrips);
    report.days = formatted;
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.REPORTS;
    var hours = report.days.map(x => { return x.hours.map(y => { return y.trips }) });
    var trips: Array<Trip> = [];
    report.days.forEach(d => {
      d.hours.forEach(h => {
        if (h.trips.length > 0) {
          trips.push(h.trips.map(x => {
            x.companyName = report.company;
            x.companyid = report.companyid;
            x.locationid = report.locationid;
            x.reportDate = moment(h.datetime.replace('GMT-0500', 'GMT-0000')).toDate();
            return x;
          }));
        }
      });
    })
    if (saveNew) {
      return this.http.post(url, report).toPromise().then(res => res.json());
    } else {
      return this.http.patch(url, report).toPromise().then(res => res.json());
    }

  }

  public updateMetaData(id, metadata) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/metadata?tripid=${id}`;
    return this.http.patch(url, metadata, { headers: headers }).toPromise().then(res => res.json());
  }

  public updateReportDate(id, reportDate) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/report-date?tripid=${id}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, { reportDate: reportDate }, { headers: headers }).toPromise().then(res => res.json());
  }

  public restore(id:String){
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/restore?id=${id}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public deleteForever(id: String) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/remove/${id}`;
    return this.http.delete(url).toPromise().then(res => res.json());
  }

  public deleteTrip(id: String) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/trash/${id}`;
    return this.http.delete(url,{ headers:headers}).toPromise().then(res => res.json());
  }

  public updateDestination(payload) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/destination`;
    return this.http.patch(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }

  /**
   * Pushes the trip to the database and reloads the properties from the database
   * The backend will handle the heavy lifting of making sure the trip is saved correctly
   * @param trip 
   * @returns 
   */
  public updateTrip(trip: Trip) {
    return new Promise((resolve, reject) => {
      const headers = new Headers({
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      });
      var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.TRIP;
      return this.http.patch(url, trip, { headers: headers }).toPromise().then(async (res) => {
        await trip.reload(this);
        resolve(res);
      }).catch(e => {
        reject(e);
      })
    })
  }


  public updateHour(id, datetime, trips) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_REPORTS;
    return this.http.patch(url, { id: id, datetime: datetime, trips: trips }).toPromise().then(res => res.json());
  }

  public getReports(query): Promise<any> {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_REPORTS;
    return this.http.post(url, query).toPromise().then(res => res.json());
  }

  public getTrip(id: string): Promise<string> {

    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.TRIP + "/" + id;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public getTripChangelog(tripId: string): Promise<any> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/${tripId}/changelog`;
    return this.http.get(url, { headers }).toPromise().then(res => res.json());
  }

  getUsersByCompanyLocation(companyid: number, locationid: number) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.USERS}/${companyid}/${locationid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getUsersByCompany(companyid: number) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.USERS}/${companyid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getAreaData(userid: number) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.USERS}/${userid}/area`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  updateTripPublishStatus(ids: Array<string>, published: boolean, notification = false) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/publish`;
    var body = {
      ids: ids,
      published: published,
      notification: notification
    }
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  optimizePassengerPosition(trip: Trip, userid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.OPTIMAL_POS}`;
    return this.http.post(url, { trip: trip, userid: userid }).toPromise().then(res => res.json());
  }


  createTripInTimeSlot(slotid, trip: Trip) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TIME_SLOT}/trip?slotid=${slotid}`;
    return this.http.post(url, trip).toPromise().then(res => res.json());
  }

  getTimeSlotStatus(request) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TIME_SLOT}/status`;
    return this.http.post(url, request).toPromise().then(res => res.json());
  }

  optimizeTimeSlot(origin: Area, timeslot: TimeSlot, runConfig: RunConfig): Promise<Array<Trip>> {
    return new Promise((resolve, reject) => {
      var body = {
        origin: origin,
        timeslot: timeslot,
        runConfig: {
          forceOverwrite: runConfig.forceOverwrite,
          companyid: runConfig.companyid,
          companyLocationId: runConfig.companyLocationId,
          selectedCompany: runConfig.selectedCompany,
          selectedLocation: runConfig.selectedLocation,
          roundTripTime: runConfig.roundTripTime,
          origin: runConfig.origin,
          avoidTolls: runConfig.avoidTolls,
          loadTime: runConfig.loadTime,
          pickupType: runConfig.pickupType
        }
      }
      const headers = new Headers({
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      });
      var url = `${ApplicationUrlSettings.NODE_API_URL}optimize-timeslot`;
      this.http.post(url, body, { headers: headers }).toPromise().then(res => res.json()).then((trips) => {
        resolve(Trip.createTripsFromRawTripData(trips));
      }).catch(e => {
        reject(e);
      });
    });
  }

  public getDeliveryFee(source,destination,waypoints,courierKey){
    var url = `${ApplicationUrlSettings.NODE_API_URL}api/delivery-fee`;
    var payload = {
      courierKey: courierKey ? courierKey : AuthService.getCourierKey(),
      source: source,
      destination: destination,
      waypoints: waypoints
    } 
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  public rawDirections(source, dest, waypoints: Array<any> = []) {
    var payload = {
      source: source,
      destination: dest,
      waypoints: waypoints
    }
    var url = `${ApplicationUrlSettings.NODE_API_URL}rawDirections`;
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  public singleReport(id): Promise<any> {
    return new Promise((resolve, reject) => {
      var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_REPORT_SINGLE + "/" + id;
      return this.http.get(url).toPromise().then((res => {
        var response = res.json();
        Report.unravel(response.data)
        resolve(response);
      })).catch(e => {
        reject(e);
      })
    });

  }

  getWeek(weekid): Promise<any> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_WEEK + "/" + weekid;
    return this.http.get(url).toPromise().then(res => res.json());
  }


  getAdminPayload() {
    return MainService.getADMINpayload();
  }

  static getADMINpayload() {
    var payload = localStorage.getItem('admin-payload');
    if (payload) {
      return JSON.parse(payload);
    } else {
      return null;
    }
  }

  getJobTypeText() {
    var payload = this.getAdminPayload();
    if (payload.type == 'BEARER') {
      return 'Stops';
    } else {
      return "Passengers";
    }
  }

  getTrash(id: string, page: number, startDate = null, endDate = null, state = null, driverid = null, companyid = null) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip/trash?p=${page}&l=10`;
    if (id) {
      url += `&id=${id}`;
    }
    if (startDate && endDate) {
      url += `&startDate=${startDate}`;
      url += `&endDate=${endDate}`;
    }
    if (state) {
      url += `&state=${state}`;
    }
    if (driverid) {
      url += `&driverid=${driverid}`;
    }
    if (companyid) {
      url += `&companyid=${companyid}`;
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  getIncompleteTrips(page: number = 1, limit: number = 50) {
    const parsedPage = Number(page) || 1;
    const parsedLimit = Number(limit) || 50;
    const safePage = Math.max(1, parsedPage);
    const safeLimit = Math.min(100, Math.max(1, parsedLimit));
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip/incomplete?page=${safePage}&limit=${safeLimit}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  getAllTrips(id: string, page: number, startDate = null, endDate = null, state = null, driverid = null, companyid = null) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}trip?p=${page}&l=10`;
    if (id) {
      url += `&id=${id}`;
    }
    if (startDate && endDate) {
      url += `&startDate=${startDate}`;
      url += `&endDate=${endDate}`;
    }
    if (state) {
      url += `&state=${state}`;
    }
    if (driverid) {
      url += `&driverid=${driverid}`;
    }
    if (companyid) {
      url += `&companyid=${companyid}`;
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public directions(trip) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_DIRECTIONS;
    var payload = {
      source: trip.source,
      destination: trip.destination,
      waypoints: trip.areas
    }
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  public getDirections(trip: Trip) {
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_DIRECTIONS;
    var payload = {
      source: trip.source,
      destination: trip.destination,
      waypoints: trip.areas
    }
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }


  adminReset(email, password, code) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}admin/reset`;
    return this.http.post(url, {
      email: email,
      password: password,
      code: code
    }).toPromise().then(res => res.json());
  }

  submitBooking(payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}booking`;
    return this.http.post(url, payload).toPromise().then(res => res.json());
  }

  sendAdminRecovery(email) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}admin/otp?email=${email}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  secondsToHoursAndMinutes(totalSeconds) {
    // Calculate hours and minutes
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    // Create an object to store the result
    const result = {
      hours: hours,
      minutes: minutes
    };

    return result;
  }

  public swapPointToPoint(tripid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/point-to-point-swap?id=${tripid}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, null, { headers: headers }).toPromise().then(res => res.json());
  }

  public recalculateDeliveryFee(tripid,providerid,cumulative = false){
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/recalculate-fee?tripid=${tripid}&providerid=${providerid}&cumulative=${cumulative}`;
    var body = {
      tripid: tripid,
      providerid: providerid,
      cumulative: cumulative
    }
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  public editArea(tripid,index,area){
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/area?id=${tripid}&index=${index}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, area, { headers: headers }).toPromise().then(res => res.json());
  }

  public addPlaceholder(tripid, payload) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/placeholder/${tripid}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }

  public getFlatrateDestinations(companyid, locationid, ratetype, swap) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/destination?companyid=${companyid}&locationid=${locationid}&ratetype=${ratetype}${swap ? '&swap=1' : ''}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public removePassenger(tripid, userid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/passenger/${tripid}/${userid}`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public cancelTrip(id) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/cancel-admin`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var body = {
      id: id
    }
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }


  startTrip(id) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/start`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var body = {
      tripid: id
    }
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  completeTrip(id) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.TRIP}/complete`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var body = {
      tripid: id
    }
    return this.http.patch(url, body, { headers: headers }).toPromise().then(res => res.json());
  }
}
